import { createContext, useContext } from "react";

import { IAttribution } from "./types";

type IAttributionContext = () => IAttribution;

const defaultAttributionContext: IAttributionContext = () => ({
  pageView: {}
});

export const AttributionContext = createContext<IAttributionContext>(defaultAttributionContext);

export const useAttributionContext = () => useContext(AttributionContext);
